import {
  AimOutlined,
  ApartmentOutlined,
  CodeSandboxOutlined,
  ControlOutlined,
  FileImageOutlined,
  FileOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  MailOutlined,
  SettingOutlined,
  SnippetsOutlined,
  UserDeleteOutlined
} from "@ant-design/icons"
import { ItemType, MenuItemType } from "antd/es/menu/interface"
import { t } from "~/languages/i18n"
import { Paths } from "../../constants"

export type MenuItem = ItemType & {
  path?: string
  permissionKey?: string
  parent?: string
  children?: MenuItem[]
  label?: string
}
interface CustomMenuItem extends MenuItemType {
  label: string
  key: string
  icon?: React.ReactNode
  children?: CustomMenuItem[]
  path?: string
  permissionKey?: string
  parent?: string
}
export const settingItems: CustomMenuItem[] = [
  {
    key: Paths.SETTINGS.LIST.PATH,
    label: Paths.SETTINGS.LIST.LABEL,
  },
  {
    key: Paths.SETTINGS.CREATE.PATH,
    label: Paths.SETTINGS.CREATE.LABEL,
  },
]

export const postItems: CustomMenuItem[] = [
  {
    key: Paths.POSTS.LIST.PATH,
    label: Paths.POSTS.LIST.LABEL,
  },
  {
    key: Paths.POSTS.CREATE.PATH,
    label: Paths.POSTS.CREATE.LABEL,
  },
  {
    key: Paths.CATEGORIES.LIST.PATH,
    label: Paths.CATEGORIES.LIST.LABEL,
  },
]

export const mediaItems: CustomMenuItem[] = [
  {
    key: Paths.MEDIA.LIST.PATH,
    label: Paths.MEDIA.LIST.LABEL,
  },
  {
    key: Paths.MEDIA.CREATE.PATH,
    label: Paths.MEDIA.CREATE.LABEL,
  },
]

export const contactForm: CustomMenuItem[] = [
  {
    key: Paths.CONTACTFORM.LIST.PATH,
    label: Paths.CONTACTFORM.LIST.LABEL,
  },
  {
    key: Paths.CONTACTFORM.CREATE.PATH,
    label: Paths.CONTACTFORM.CREATE.LABEL,
  },
]

export const usersItems: CustomMenuItem[] = [
  {
    key: Paths.USERS.LIST.PATH,
    label: Paths.USERS.LIST.LABEL,
  },
  {
    key: Paths.USERS.CREATE.PATH,
    label: Paths.USERS.CREATE.LABEL,
  },
  {
    key: Paths.USERS.PROFILE.PATH,
    label: Paths.USERS.PROFILE.LABEL,
  },
]

export const pageItems: CustomMenuItem[] = [
  {
    key: Paths.PAGES.LIST.PATH,
    label: Paths.PAGES.LIST.LABEL,
  },
  {
    key: Paths.PAGES.CREATE.PATH,
    label: Paths.PAGES.CREATE.LABEL,
  },
]
export const baseItems: CustomMenuItem[] = [
  {
    key: Paths.BASESYSTEM.LIST.PATH,
    label: Paths.BASESYSTEM.LIST.LABEL,
  },
  {
    key: Paths.BASESYSTEM.CREATE.PATH,
    label: Paths.BASESYSTEM.CREATE.LABEL,
  },
]

export const recruitmentItems: CustomMenuItem[] = [
  {
    key: Paths.RECRUITMENT.LIST.PATH,
    label: Paths.RECRUITMENT.LIST.LABEL,
  },
  {
    key: Paths.RECRUITMENT.CREATE.PATH,
    label: Paths.RECRUITMENT.CREATE.LABEL,
  },
]

export const jobDetailItems: CustomMenuItem[] = [
  {
    key: Paths.JOB_DETAIL.LIST.PATH,
    label: Paths.JOB_DETAIL.LIST.LABEL,
  },
  {
    key: Paths.JOB_DETAIL.CREATE.PATH,
    label: Paths.JOB_DETAIL.CREATE.LABEL,
  },
]

export const parentQuestionItems: CustomMenuItem[] = [
  {
    key: Paths.PARENT_QUESTIONS.LIST.PATH,
    label: Paths.PARENT_QUESTIONS.LIST.LABEL,
  },
  {
    key: Paths.PARENT_QUESTIONS.CREATE.PATH,
    label: Paths.PARENT_QUESTIONS.CREATE.LABEL,
  },
]

export const menuItems: Array<CustomMenuItem> = [
  { label: "Dashboard", key: "dashboard", icon: <HomeOutlined /> },
  { label: "Post", key: "post", icon: <FileOutlined />, children: postItems, permissionKey: "post" },
  { label: "Page", key: "pages", icon: <SnippetsOutlined />, children: pageItems, permissionKey: "page" },
  // {
  //   label: "Recruitment",
  //   key: "recruitment",
  //   icon: <UsergroupAddOutlined />,
  //   children: recruitmentItems,
  //   permissionKey: "recruitment",
  // },
  // {
  //   label: "Job Detail",
  //   key: "job-detail",
  //   icon: <UsergroupAddOutlined />,
  //   children: jobDetailItems,
  //   permissionKey: "job-detail",
  // },
  { label: "Media", key: "upload", icon: <FileImageOutlined />, children: mediaItems, permissionKey: "content-api" },
  { label: "Menus", key: "menus", icon: <ControlOutlined />, permissionKey: "menu-preference" },
  { label: "Content Templates", key: "block-content", icon: <AimOutlined />, permissionKey: "block-content" },
  { label: "Users", key: "users", children: usersItems, icon: <UserDeleteOutlined />, permissionKey: "user" },
  { label: "Settings", key: "settings", icon: <SettingOutlined />, children: settingItems, permissionKey: "setting" },
  {
    label: "Contact Form",
    key: "contactform",
    icon: <MailOutlined />,
    children: contactForm,
    permissionKey: "contact-form",
  },
  { label: "General Setting", key: "general-setting", icon: <CodeSandboxOutlined />, permissionKey: "setting" },
  {
    label: "Base System",
    key: "base-system",
    icon: <ApartmentOutlined />,
    children: baseItems,
    permissionKey: "base-system",
  },
  {
    label: t("Parent Questions"),
    key: "parent-questions",
    icon: <InfoCircleOutlined />,
    children: parentQuestionItems,
  },
]

const filterMenuItemsByPermission = (menuItems: MenuItem[], permissions: Record<string, any>): MenuItem[] => {
  return menuItems.reduce<MenuItem[]>((filteredMenuItems, item) => {
    const permissionKey = item.permissionKey

    if (permissionKey) {
      const hasPermission = permissions[permissionKey]?.find?.enabled === true

      if (hasPermission) {
        if (item.children?.length) {
          const filteredChildren = item.children.filter(child => {
            const path = child.key?.toString() || ""

            if (path.includes("/create")) {
              return permissions[permissionKey]?.create?.enabled === true
            }
            return true
          })

          if (filteredChildren.length) {
            filteredMenuItems.push({
              ...item,
              children: filteredChildren,
            })
          }
        } else {
          filteredMenuItems.push(item)
        }
      }
    } else {
      filteredMenuItems.push(item)
    }

    return filteredMenuItems
  }, [])
}

export const getFilteredMenuItems = (): MenuItem[] => {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}")

  const filteredMenuItems = filterMenuItemsByPermission(menuItems, permissions)

  return filteredMenuItems
}
